import axios from "axios";
import config from "../../config";

function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}

export const getAnalytics = async ({ period, chain, interval, offices }) => {
  try {
    const params = new URLSearchParams();
    params.append("period", period);
    params.append("chain", chain);
    params.append("interval", interval.toString());

    // Add each office individually without brackets
    offices.forEach((office) => {
      params.append("offices", office);
    });

    const response = await axios.get(`${config.apiGateway.URL}/data-analytics/admin-dashboard/`, {
      params,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};

export const getObjectAnalyser = async ({ time_type, period, interval, offices, objanalyser_id }) => {
  try {
    const params = new URLSearchParams();
    params.append("time_type", time_type);
    params.append("period", period);
    params.append("interval", interval.toString());
    params.append("objanalyser_id", objanalyser_id);

    // Add each office individually without brackets
    offices.forEach((office) => {
      params.append("offices", office.toString());
    });

    const response = await axios.get(`${config.apiGateway.URL}/data-analytics/object-Analyser/`, {
      params,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching object analyser:", error);
    throw error;
  }
};

export const getChains = async () => {
  try {
    const response = await axios.get(`${config.apiGateway.URL}/data-analytics/chains/`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching chains:", error);
    throw error;
  }
};

export const getOffices = async () => {
  try {
    const response = await axios.get(`${config.apiGateway.URL}/clinics/offices/`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching offices:", error);
    throw error;
  }
};

export const getObjectAnalyserList = async () => {
  try {
    const response = await axios.get(`${config.apiGateway.URL}/data-analytics/object-Analyser-list/`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching object analyser list:", error);
    throw error;
  }
};

export const controller = {
  getAnalytics,
  getChains,
  getOffices,
};
